import React from 'react';
import { useNavigate } from 'react-router-dom';
import BackGrowndParticles from '../components/BackGrowndParticles'; 
import './Mobile.css'

const Mobile = () => {
  const navigate = useNavigate();  

  function getRandomNumber() {
    return Math.floor(Math.random() * 8) + 1;
  }

  const handleExploreClick = () => {    
    navigate('/About/1');
  };

  return (
    <>   
    <div style={{
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100vw',  // 100% of the viewport width
        height: '100vh', // 100% of the viewport height
        backgroundColor: '#0b0426', // Optional: add a background color
        zIndex: '2', // Optional: place it above other content
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        justifyContent:'center'
      }}>
      <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 0 }}>
        <BackGrowndParticles />
      </div>
      <div style={{display:'flex', flexDirection:'column', alignItems:'center', position:'relative', zIndex:'1'}}>
        <img style={{width:'80%'}} alt='logo' src={require(`../images/logo/all_bgs/logo${getRandomNumber()}.png`)}/>
      </div>
      
      <div style={{ width: '80%', display: 'flex', flexDirection: 'column', justifyContent: 'center', margin:'50px', textAlign:'justify', color:'#bdbdbd' }}>        
        Crypto Proton is currently optimized for desktop to give you the best user experience. While we plan to make it mobile-friendly in the future, for now, we recommend using it on desktop for the best performance and overall experience      
      </div>

      <div style={{display:'flex', flexDirection:'column', alignItems:'center', position:'relative', zIndex:'1'}}>      
        <button className="explore-button" onClick={handleExploreClick}>
        What is Crypto Proton by the way?
        </button>
      </div>
    </div>
    </>
    
  );
};

export default Mobile;

  






